import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { FullScreenLoader } from "@/components/FullScreenLoader";
import { FriendChatDock } from "@/components/FriendChatDock";
import BlockedScreen from "@/pages/BlockedScreen";

/* Routes purely on the AuthContext state machine — no local state, no timer,
   no getSession call. See AuthContext for the state definitions. */

export default function ProtectedRoute({ children }) {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === "initializing") return <FullScreenLoader label="Loading" />;
  if (status === "anonymous") return <Navigate to="/login" replace />;
  // Blocked users are kept out of every product route. Show a dedicated
  // screen that explains why instead of silently signing them out.
  if (user?.is_blocked) return <BlockedScreen />;

  // Suppress the global chat dock during an active LiveKit call — the video
  // page has its own controls and the dock would just steal focus.
  const suppressDock =
    location.pathname.startsWith("/video-call") ||
    location.pathname.startsWith("/matchmaking");

  return (
    <>
      {children}
      {!suppressDock && <FriendChatDock />}
    </>
  );
}
